module.exports = __webpack_public_path__ + "img/bh_8.55566ab8.jpg";